import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import InsightFiltersViewModel from "../../../ViewModels/InsightFiltersViewModel";

interface ISelectFilterDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    filters: InsightFiltersViewModel
    setFilters: React.Dispatch<React.SetStateAction<InsightFiltersViewModel>>
    name: string
    label: string
    options: any[]
}

export default function SelectFilterDialog(
    { open, setOpen, filters, setFilters, name, label, options }: ISelectFilterDialogProps) {

    useEffect(() => {
        setValue(filters[name])
    }, [filters[name]])

    const [value, setValue] = useState<string>(filters[name])

    const confirm = () => {
        setFilters(prevState => ({
            ...prevState,
            [name]: value
        }));

        setOpen(false);
    }

    const onValueChange = (event: any) => {
        setValue(event.target.value);
    }

    const clearValue = () => {
        setValue('');
    }

    return (
        <>
            <Dialog open={open} fullWidth maxWidth='sm'>
                <DialogTitle>{`${label} Filter`}</DialogTitle>
                <Grid container justifyContent='center'>
                    <Grid size={8}>
                        <InputLabel>{label}</InputLabel>
                        <Select
                            name="preset"
                            onChange={onValueChange}
                            value={value}
                            fullWidth
                            endAdornment={value &&
                                <IconButton onClick={() => clearValue()} sx={{ marginRight: 2 }}>
                                    <ClearIcon />
                                </IconButton>}
                        >
                            {
                                options.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)
                            }
                        </Select>
                    </Grid>
                </Grid>
                <DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button onClick={confirm}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
